import styled from 'styled-components';

export const HeaderContainer = styled.header`
  background-color: var(--primary-color);
  color: var(--light-text);
  padding: 1rem 0;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    padding: 0.75rem 0;
  }
`;

export const HeaderContent = styled.div`
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Logo = styled.div`
  a {
    color: var(--light-text);
    display: flex;
    align-items: center;
  }

  img {
    height: 40px;
    width: auto;
    margin-right: 10px;
    border-radius: 4px;
    transition: transform 0.3s ease;
  }

  a:hover img {
    transform: scale(1.05);
  }

  div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  h1 {
    font-size: 1.5rem;
    font-weight: 700;
    margin: 0;
    letter-spacing: 1px;
  }

  p {
    font-size: 0.9rem;
    margin: 0;
    font-weight: 300;
  }

  @media (max-width: 768px) {
    img {
      height: 30px;
    }

    h1 {
      font-size: 1.2rem;
    }

    p {
      font-size: 0.8rem;
    }
  }
`;

export const Nav = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const NavItem = styled.li`
  margin-left: 2rem;

  a {
    color: var(--light-text);
    font-weight: 500;
    position: relative;
    padding-bottom: 5px;

    &:after {
      content: '';
      position: absolute;
      width: 0;
      height: 2px;
      bottom: 0;
      left: 0;
      background-color: var(--light-text);
      transition: width 0.3s ease;
    }

    &:hover:after {
      width: 100%;
    }
  }
`;

export const MobileMenuButton = styled.button`
  background: transparent;
  border: none;
  color: var(--light-text);
  font-size: 1.5rem;
  cursor: pointer;
  display: none;
  padding: 0.5rem;

  @media (max-width: 768px) {
    display: block;
  }
`;

export const LanguageSelector = styled.div`
  display: flex;
  align-items: center;
  margin-left: 2rem;
  border-radius: 4px;
  overflow: hidden;
  background-color: rgba(255, 255, 255, 0.1);

  @media (max-width: 768px) {
    display: none;
  }
`;

interface LanguageOptionProps {
  active: boolean;
}

export const LanguageOption = styled.button<LanguageOptionProps>`
  background-color: ${props => props.active ? 'rgba(255, 255, 255, 0.2)' : 'transparent'};
  border: none;
  color: var(--light-text);
  padding: 0.3rem 0.6rem;
  font-size: 0.8rem;
  font-weight: ${props => props.active ? '600' : '400'};
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
`;